import React from "react";
import { motion } from "framer-motion";
import TestimonialCard from "./TestimonialCard";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const TestimonialsSection = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const sectionData = labels.menuPages?.sellCar?.testimonialsSection || {};
  const testimonials = sectionData.testimonials || [];

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
      className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-3xl p-12 max-w-6xl mx-auto"
    >
      <h3 className="text-3xl font-bold text-center text-gray-900 mb-12">
        {sectionData.title || "Vad Våra Kunder Säger"}
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {testimonials.map((testimonial, index) => (
          <TestimonialCard
            key={index}
            testimonial={testimonial}
            index={index}
          />
        ))}
      </div>
    </motion.div>
  );
};

export default TestimonialsSection;
